import { getApiBaseUrl } from './apiBaseUrl';

/**
 * Build a browser-accessible URL for files stored in the cmp-proposals bucket.
 * @param {string|null|undefined} storageKey
 * @returns {string}
 */
export function buildProposalMediaUrl(storageKey) {
  if (!storageKey) return '';
  if (/^https?:\/\//i.test(storageKey)) return storageKey;
  const base = getApiBaseUrl();
  return `${base}/media/proposals/${storageKey.replace(/^\//, '')}`;
}

/**
 * Build a browser-accessible URL for KYC / arbitrator documents.
 * @param {string|null|undefined} storageKey
 * @returns {string}
 */
export function buildKycMediaUrl(storageKey) {
  if (!storageKey) return '';
  if (/^https?:\/\//i.test(storageKey)) return storageKey;
  const base = getApiBaseUrl();
  let key = storageKey.replace(/^\//, '');
  if (key.startsWith('kyc-docs/')) {
    key = key.slice('kyc-docs/'.length);
  }
  return `${base}/media/kyc-docs/${key}`;
}
